// import Vue from 'vue'
import VueRouter from 'vue-router'

// 自定义组件
import Login from '../view/login/login.vue'
import Error from '../view/login/error.vue'
import Home from '../view/home/home.vue'
import Data from '../view/home/index.vue'
import Index from '../view/center/center.vue'
import Display from '../view/home/display.vue'


import MonitorEquipment from '../view/monitor/equipment/equipment-monitor.vue'
import MonitorEquipmentDetail from '../view/monitor/equipment/equipment-monitor-detail.vue'
import MonitorEquipmentDetailHandle from '../view/monitor/equipment/equipment-monitor-detail-handle.vue'
import MonitorEquipmentMaintainRecord from '../view/monitor/equipment/equipment-monitor-maintainrecord.vue'
import MonitorConsumables from '../view/monitor/consumables/consumables-monitor.vue'
import MonitorConsumablesHospital from '../view/monitor/consumables/consumables-monitor-hospital.vue'

// manage
import ConsumablesList from '../view/manage/consumables/consumables-list.vue'
import ConsumablesAdd from '../view/manage/consumables/consumables-add.vue'
import ConsumablesEdit from '../view/manage/consumables/consumables-edit.vue'
import ConsumablesHospitalList from '../view/manage/consumables/consumables-hospital-list.vue'

import UserList from '../view/manage/user/user-list.vue'
import UserAdd from '../view/manage/user/user-add.vue'
import UserEdit from '../view/manage/user/user-edit.vue'


import GroupList from '../view/manage/group/group-list.vue'
import GroupAdd from '../view/manage/group/group-add.vue'
import GroupEdit from '../view/manage/group/group-edit.vue'

import KnowledgeList from '../view/manage/knowledge/knowledge-list.vue'
import KnowledgeAdd from '../view/manage/knowledge/knowledge-add.vue'

import EquipmentList   from '../view/manage/equipment/equipment-list.vue'
import EquipmentAdd   from '../view/manage/equipment/equipment-add.vue'
import EquipmentUsingRecordOne from '../view/manage/equipment/equipment-using-record-one.vue'
import EquipmentHospital from '../view/manage/equipment/equipment-hospital-one'
import EquipmentEdit   from '../view/manage/equipment/equipment-edit.vue'
import EquipmentBind   from '../view/manage/equipment/equipment-bind.vue'
import EquipmentDetails   from '../view/manage/equipment/equipment-details.vue'
import EquipmentDataDownload   from '../view/manage/equipment/equipment-data-download.vue'
import EquipmentFileDownload   from '../view/manage/equipment/equipment-file-download.vue'


import RulesList from '../view/manage/rules/rules-list.vue'
import RulesAddEquip from '../view/manage/rules/rules-add-equip.vue'
import RulesAddCons from '../view/manage/rules/rules-add-cons.vue'

import IPList from '../view/manage/ip/ip-list.vue'
import IPLimitAdd from '../view/manage/ip/ip-add.vue'
import TimeLimitAdd from '../view/manage/ip/time-add.vue'

import Log from '../view/system/log.vue'
import Manual from '../view/system/manual.vue'
import Feedback from '../view/system/feedback.vue'
import FeedbackList from '../view/system/feedback-list.vue'
import About from '../view/system/about.vue'
import News from '../view/system/news.vue'
import equipmentFileDownloadVue from '../view/manage/equipment/equipment-file-download.vue'

// import equipmentDataDownloadVue from '../view/manage/equipment/equipment-data-download.vue'


//1注入插件
// Vue.use(VueRouter)
// 1全局路由
// const  globalRoutes = [
//   {
//     path: '/login',
//     name: 'Login',
//     meta: {title: '登录'},
//     isHide: true,
//     component: Login
//   },
//   {
//     path: '/404',
//     name: '404',
//     isHide: true,
//     component: Error
//   }
// ]

// 2主入口路由
const routes = [
    {
      path: '/',
      name: 'Home',
      component: Home,
      redirect: {name: 'Index'},
        children:[
          {
            path: '/index',
            name: 'Index',
            meta: {
              title: '个人中心',
              needLogin:true,
            },
            isHide: true,
            component: Index,
          },
          {
            path: '/data',
            name: 'Data',
            component:Data,
            meta: {
              title:'数据展示',
              needLogin:true,
            }
          },
          {
            path: '/monitor/equipment/equipment-monitor',
            name: 'MonitorEquipment',
            component: MonitorEquipment,
            meta: {
              title: '设备监控',
              needLogin:true,
            }
          },{
            path:'/monitor/equipment/equipment-monitor-detail',
            name:'MonitorEquipmentDetail',
            component: MonitorEquipmentDetail,
            meta: {
              title: '设备监控详情',
              activeMenu: '/monitor/equipment/equipment-monitor',
              needLogin:true,
            }
          },{
            path: '/monitor/equipment/equipment-monitor-detail-handle',
            name:'MonitorEquipmentDetailHandle',
            component: MonitorEquipmentDetailHandle,
            meta: {
              title: '处理信息添加',
              activeMenu: '/monitor/equipment/equipment-monitor',
              needLogin:true,
            }
          },{
            path: '/monitor/equipment/equipment-monitor-maintainrecord',
            name:'MonitorEquipmentMaintainRecord',
            component: MonitorEquipmentMaintainRecord,
            meta: {
              title: '设备维护记录',
              activeMenu: '/monitor/equipment/equipment-monitor',
              needLogin:true,
            }
          },{
            path: '/monitor/consumables/consumables-monitor',
            name: 'MonitorConsumables',
            component: MonitorConsumables,
            meta: {
              title: '耗材告警',
              needLogin:true,
            }
          },{
            path: '/monitor/consumables/consumables-monitor-hospital',
            name: 'MonitorConsumablesHospital',
            component: MonitorConsumablesHospital,
            meta: {
              title: '耗材告警关联医院',
              activeMenu: '/monitor/consumables/consumables-monitor',
              needLogin:true,
            }
          },{
            path: '/manage/rules/rules-list',
            name: 'RulesList',
            component: RulesList,
            meta: {
              title: '规则管理',
              needLogin:true,
            },
          },{
            path: '/manage/rules/rules-add-equip',
            name: 'RulesAddEquip',
            component: RulesAddEquip,
            meta: {
              title: '添加设备识别规则',
              activeMenu: '/manage/rules/rules-list',
              needLogin:true,
            },
          },{
            path: '/manage/rules/rules-add-cons',
            name: 'RulesAddCons',
            component: RulesAddCons,
            meta: {
              title: '添加耗材识别规则',
              activeMenu: '/manage/rules/rules-list',
              needLogin:true,
            },
          },{
            path: '/manage/equipment/equipment-list',
            name: 'EquipmentList',
            component: EquipmentList,
            meta: {
              title: '设备管理',
              needLogin:true,
            },
          },{
            path:'/manage/equipment/equipment-add',
            name:'EquipmentAdd',
            component: EquipmentAdd,
            meta: {
              title: '设备注册',
              activeMenu: '/manage/equipment/equipment-list',
              needLogin:true,
            }
          },{
            path:'/manage/equipment/equipment-edit',
            name:'EquipmentEdit',
            component: EquipmentEdit,
            meta: {
              title: '设备修改',
              activeMenu: '/manage/equipment/equipment-list',
              needLogin:true
            }
          },{
            path:'/manage/equipment/equipment-bind',
            name:'EquipmentBind',
            component: EquipmentBind,
            meta: {
              title: '账号绑定',
              activeMenu: '/manage/equipment/equipment-list',
              needLogin:true
            }
          },{
            path: '/manage/equipment/equipment-details',
            name:'EquipmentDetails',
            component: EquipmentDetails,
            meta: {
              title: '设备详情',
              activeMenu: '/manage/equipment/equipment-list',
              needLogin:true
            }
          },{
            path: '/manage/equipment/equipment-data-download',
            name:'EquipmentDataDownload',
            component: EquipmentDataDownload,
            meta: {
              title: '手术数据下载',
              activeMenu: '/manage/equipment/equipment-list',
              needLogin:true
            }
          },{
            path: '/manage/equipment/equipment-file-download',
            name:'EquipmentFileDownload',
            component: EquipmentFileDownload,
            meta: {
              title: '设备文件下载',
              activeMenu: '/manage/equipment/equipment-list',
              needLogin:true
            }
          },{
            path: '/manage/equipment/equipment-using-record-one',
            name: 'EquipmentUsingRecordOne',
            component: EquipmentUsingRecordOne,
            meta: {
              title: '使用数据',
              activeMenu: '/manage/equipment/equipment-list',
              needLogin:true
            }
          },{
            path: '/manage/equipment/equipment-hospital-one',
            name: 'EquipmentHospital',
            component: EquipmentHospital,
            meta: {
              title: '医院详情',
              activeMenu: '/manage/equipment/equipment-list',
              needLogin:true
            }
          },{
            path: '/manage/consumables/consumables-list',
            name: 'ConsumablesList',
            component: ConsumablesList,
            meta: {
              title:'耗材管理',
              path: '/manage/consumables/consumables-list',
              needLogin:true
            }
          },{
            path:'/manage/consumables/consumables-add',
            name:'ConsumablesAdd',
            component: ConsumablesAdd,
            meta: {
              title: '添加耗材',
              activeMenu: '/manage/consumables/consumables-list',
              needLogin:true
            }
          },{
            path:'/manage/consumables/consumables-edit',
            name:'ConsumablesEdit',
            component: ConsumablesEdit,
            meta: {
              title: '耗材出库',
              activeMenu: '/manage/consumables/consumables-list',
              needLogin:true
            }
          },{
            path: '/manage/consumables/consumables-hospital-list',
            name: 'ConsumablesHospitalList',
            component: ConsumablesHospitalList,
            meta: {
              title:'医院耗材详情',
              activeMenu: '/manage/consumables/consumables-list',
              needLogin:true
            }
          },{
            path: '/manage/user/user-list',
            name: 'UserList',
            component: UserList,
            meta: {
              title: '用户管理',
              needLogin:true
            }
          },{
            path: '/manage/user/user-add',
            name: 'UserAdd',
            component: UserAdd,
            meta: {
              title: '添加用户' ,
              activeMenu: '/manage/user/user-list',
              needLogin:true
            }
          },{
            path: '/manage/user/user-edit',
            name: 'UserEdit',
            component: UserEdit,
            meta: {
              title: '修改用户' ,
              activeMenu: '/manage/user/user-list',
              needLogin:true
            }
          },{
            path: '/manage/group/group-list',
            name: 'GroupList',
            component: GroupList,
            meta: {
              title: '分组管理',
              needLogin:true
            }
          },{
            path: '/manage/group/group-add',
            name: 'GroupAdd',
            component: GroupAdd,
            meta: {
              title: '添加分组',
              activeMenu: '/manage/group/group-list',
              needLogin:true
            }
          },{
            path: '/manage/group/group-edit',
            name: 'GroupEdit',
            component: GroupEdit,
            meta: {
              title: '修改分组',
              activeMenu: '/manage/group/group-list',
              needLogin:true
            }
          },{
            path: '/manage/knowledge/knowledge-list',
            name: 'KnowledgeList',
            component: KnowledgeList,
            meta: {
              title: '知识库管理',
              needLogin:true
            }
          },{
            path: '/manage/knowledge/knowledge-add',
            name: 'KnowledgeAdd',
            component: KnowledgeAdd,
            meta: {
              title:'添加知识库',
              activeMenu: '/manage/knowledge/knowledge-list',
              needLogin:true
            }
          },
          {
            path: '/manage/ip/ip-list',
            name: 'IPList',
            component: IPList,
            meta: {
              title:'IP管理',
              needLogin:true
            }
          },
          {
            path: '/manage/ip/ip-add',
            name: 'IPLimitAdd',
            component: IPLimitAdd,
            meta: {
              title:'添加IP地址',
              activeMenu: '/manage/ip/ip-list',
              needLogin:true
            }
          },
          {
            path: '/manage/ip/time-add',
            name: 'TimeLimitAdd',
            component: TimeLimitAdd,
            meta: {
              title:'添加IP地址',
              activeMenu: '/manage/ip/ip-list',
              needLogin:true
            }
          },
          {
            path: '/system/log',
            name: 'Log',
            component: Log,
            meta: {
              title:'系统日志',
              needLogin:true
            }
          },{
            path: '/system/manual',
            name: 'Manual',
            component: Manual,
            meta: {
              title:'用户手册',
              needLogin:true
            }
          },{
            path: '/system/feedback',
            name: 'Feedback',
            component: Feedback,
            meta: {
              title:'意见反馈',
              needLogin:true
            }
          },
          {
            path: '/system/feedback-list',
            name: 'FeedbackList',
            component: FeedbackList,
            meta: {
              title:'全部反馈',
              activeMenu: '/system/feedback',
              needLogin:true
            }
          },
          {
            path: '/system/about',
            name: 'About',
            component: About,
            meta: {
              title:'系统关于',
              needLogin:true
            }
          },
          {
            path: '/system/news',
            name: 'News',
            component: News,
            meta: {
              title:'消息提醒',
              needLogin:true
            }
          }]
    },
    {
      path:'/display',
      name:'Display',
      meta:{
        title:'大屏1',
        path: '/display',
        needLogin:true
      },
      isHide:true,
      component:Display
    },
    {
      path: '/login',
      name: 'Login',
      meta: {
        title: '登录',
        path: '/login',
        needLogin:false
      },
      isHide: false,
      component: Login,
    },
    {
      path: '/404',
      name: '404',
      isHide: true,
      component: Error,
      needLogin:false
    }

  ]

const router = new VueRouter({
  // mode: 'history',
  routes
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js